<div class="search-bar-field-user">
  <span *ngIf="filter.key == 'user_owner' || filter.key == 'user'">
    <span>By </span>
    <span class="user-action" title="{{filter.item.name}}">
        {{filter.item.name}}
    </span>
  </span>
  <span *ngIf="filter.key == 'user_assigned'">
    <span>Assigned to > </span>
    <span class="user-action" title="{{filter.item.name}}">
        {{filter.item.name}}
    </span>
  </span>
  <span *ngIf="filter.key == 'feedback_requestor'">
    <span>Requested by > </span>
    <span class="user-action" title="{{filter.item.name}}">
        {{filter.item.name}}
    </span>
  </span>
  <span *ngIf="filter.key == 'feedback_user'">
    <span>Recipient > </span>
    <span class="user-action" title="{{filter.item.name}}">
        {{filter.item.name}}
    </span>
  </span>
  <span
      title="Remove {{filter.key}} filter"
      class="users-action-btn"
      [ngClass]="style"
      (click)="onRemove(filter)"
  >X</span>
</div>
